import React, { useState, useRef } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './componts.css';

function FloatingSingleCol({ title, href, links, featured, twoCol }) {
  const [open, setOpen] = useState(false);
  const closeTimer = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(closeTimer.current);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    closeTimer.current = setTimeout(() => setOpen(false), 120);
  };

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {href ? (
        <a href={href} className="dropbtn">
          {title} <span style={{ fontSize: '0.65em', opacity: 0.7, marginLeft: 2 }}>▾</span>
        </a>
      ) : (
        <button className="dropbtn" aria-expanded={open} aria-label={`${title} navigation menu`}>
          {title} <span style={{ fontSize: '0.65em', opacity: 0.7, marginLeft: 2 }}>▾</span>
        </button>
      )}

      {open && (
        <div className="mega-panel">
          {/* Links column */}
          <div className={`mega-panel__links${twoCol ? ' mega-panel__links--two-col' : ''}`}>
            {links.map((link, idx) => (
              <a key={link.href || idx} href={link.href} className="mega-link">
                {link.icon && (
                  <span className="mega-link__icon">
                    <i className={`bi ${link.icon}`} />
                  </span>
                )}
                <span className="mega-link__text">{link.name}</span>
                <i className="bi bi-chevron-right mega-link__arrow" />
              </a>
            ))}
          </div>

          {/* Featured card — only shown when content is provided */}
          {featured && (
            <>
              <div className="mega-panel__divider" />
              <div className="mega-panel__featured">
                <a href={featured.href} className="mega-featured-card">
                  {featured.img && (
                    <div className="mega-featured-card__img-wrap">
                      <img src={featured.img} alt={featured.label} />
                      <span className="mega-featured-card__badge">{featured.badge}</span>
                    </div>
                  )}
                  <p className="mega-featured-card__date">{featured.date}</p>
                  <h4 className="mega-featured-card__headline">{featured.headline}</h4>
                  <span className="mega-featured-card__read">Read more →</span>
                </a>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default FloatingSingleCol;
